import { mainApi } from "../services/main/api";
import {
    IPropertyDetails,
    ISpaceDetails,
    IFeatureDetails,
    ISiteImprovementDetails,
} from "./getRealProperty";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        createRealProperty: builder.mutation<RealPropertyResponse, RealPropertyRequest>({
            query: (request?: RealPropertyRequest) => ({
                url: "createRealProperty",
                body: request,
                method: "POST",
            }),
        }),
        updateRealProperty: builder.mutation<UpdateRealPropertyResponse, UpdateRealPropertyRequest>(
            {
                query: (request?: UpdateRealPropertyRequest) => ({
                    url: "updateRealProperty",
                    body: request,
                    method: "POST",
                }),
            }
        ),
    }),
    overrideExisting: false,
});

export const { useCreateRealPropertyMutation, useUpdateRealPropertyMutation } = extendedApi;

export interface RealPropertyRequest {
    businessUseCase: "SMART";
    clientName: string;
    propertyDetails: IPropertyDetails;
    featureDetails: IFeatureDetails[];
    siteImprovementDetails: ISiteImprovementDetails[];
    spaceDetails: ISpaceDetails[];
}

export interface RealPropertyResponse {
    artifactId: string;
}
export type updateType = "created" | "modified" | "deleted";

export interface UpdateRealPropertyRequest {
    businessUseCase: "SMART";
    clientName: string;
    propertyDetails: IPropertyDetails;
    artifactId: string;
    featureDetails: {
        created: IFeatureDetails[];
        modified: IFeatureDetails[];
        deleted: IFeatureDetails[];
    };
    siteImprovementDetails:
        | {
              created: ISiteImprovementDetails[];
              modified: ISiteImprovementDetails[];
              deleted: ISiteImprovementDetails[];
          }
        | any;
    spaceDetails:
        | {
              created: ISpaceDetails[];
              modified: ISpaceDetails[];
              deleted: ISpaceDetails[];
          }
        | any;
}

export interface UpdateRealPropertyResponse {
    artifactId: string;
}
